module.exports = __webpack_public_path__ + "img/industrial_process.daaa8442.svg";